export enum IRAAutoMaxCartActionTypes {
  // TOGGLE DAY/MONTH ACTIONS
  IRA_AUTO_MAX_SELECT_MONTH = 'IRA_AUTO_MAX_SELECT_MONTH',
  IRA_AUTO_MAX_SELECT_DAY = 'IRA_AUTO_MAX_SELECT_DAY',
  // WINDOW ACTIONS
  IRA_AUTO_MAX_WINDOW = 'IRA_AUTO_MAX_WINDOW',
  IRA_AUTO_MAX_WINDOW_PENDING = 'IRA_AUTO_MAX_WINDOW_PENDING',
  IRA_AUTO_MAX_WINDOW_FULFILLED = 'IRA_AUTO_MAX_WINDOW_FULFILLED',
  IRA_AUTO_MAX_WINDOW_REJECTED = 'IRA_AUTO_MAX_WINDOW_REJECTED',
}
